import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

/** By default, we don't need styling, we only need to override some values for 777, harrahs and wsop */
const BalanceTitleInnerDefaultBox = styled.span``;

const BalanceTitleInnerCasino777Box = styled(BalanceTitleInnerDefaultBox)`
    /* .cash-balance-title, .bonus-balance-title */
    /* 777 */
    color: ${({theme}) => theme.colors.userMenuBalanceTitle};
    font-family: ${({theme}) => theme.font.family.medium};
`;

const BalanceTitleInnerHarrahsWsopBox = styled(BalanceTitleInnerDefaultBox)`
    /* harrahs */
    /* wsop */
    color: ${({theme}) => theme.colors.userMenuBalanceTitle};
    font-family: ${({theme}) => theme.font.family.regular};
`;

export const BalanceTitleInnerBox = styledByTheme(BalanceTitleInnerDefaultBox)
    .forCasino777(BalanceTitleInnerCasino777Box)
    .forHarrahs(BalanceTitleInnerHarrahsWsopBox)
    .forWsop(BalanceTitleInnerHarrahsWsopBox)
    .apply();
